<template>
    <div id="layout">
      <div
        id="viewer-container"
        style="height: 100%"
      >
      <ar-button v-if="$vuetify.display.smAndDown && isProductLoaded" :change-color="changeColor" @arClick="$emit('arClick')"/>
      </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import parameters from '../../js/parameters.js'
    import ArButton from '../gamepad/ArButton.vue'
    export default {
        name: 'InspiViewer',

        data () {
      return {
        isViewerLoaded: false,
      }
    },

    components: {
      ArButton,

    },

    computed: {
      ...mapGetters(['isProductLoaded', 'getInspiViewerSrc', 'getInspiViewerUser', 'getInspiViewerToken', 'isProductLoaded']),
    },

    props: {
      changeColor: Boolean,
    },

    mounted () {
      this.loadViewer()
    },

    emits: ['arClick'],

    methods: {
      loadViewer () {
        if (this.isViewerLoaded) return
        this.isViewerLoaded = true

        const viewer = document.createElement('inspi-viewer')
        viewer.id = 'inspi-viewer'
        viewer.setAttribute('loadersrc', require('@/assets/Logo-HBM-black-256.png'))
        viewer.setAttribute('loadergifsrc', require('@/assets/loader.gif'))
        parameters.apply(viewer)
        viewer.setAttribute('cat', '112')
        viewer.setAttribute('productref', 'Cuisine-HBM')
        viewer.setAttribute('noinitanimation', true)
        const container = document.querySelector('#viewer-container')
        container.appendChild(viewer)

        const script = document.createElement('script')
        script.setAttribute('src', this.getInspiViewerSrc)
        script.setAttribute('user', this.getInspiViewerUser)
        script.setAttribute('token', this.getInspiViewerToken)
        document.head.appendChild(script)
      },
    },
  }
</script>

<style scoped>
#layout {
  position: relative;
  width: 100%;
  height: 100%;
}

#viewer-container {
  width: 100%;
}

.upper-watermark {
  z-index: 10;
}
</style>
